import {Component, ElementRef, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {RequestService} from "../../core/services/request/request.service";
import {Subscription} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";
import {ReportService} from "../../core/services/report/report.service";

enum DisplayType {
  ReportDrillDown,
}

@Component({
  selector: 'sb-report-page',
  templateUrl: './report-page.component.html',
  styleUrls: ['./report-page.component.scss']
})
export class ReportPageComponent implements OnInit {

  @ViewChild('target')
  target: ElementRef<HTMLElement>;

  knockoutTemplateRendered: boolean = false;

  displayType: DisplayType;

  activatedRouteSubscription: Subscription | null;

  table: string; // Table the report is on
  rsid: string; // ResultSet ID in the ReportService
  ddid: string; // DrillDown ID in the ReportService

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private requestService: RequestService,
              private reportService: ReportService) {
  }

  ngOnInit(): void {

    // Wipe out the page context
    (window as any).KO_PAGE_CONTEXT.clear();

    // Wipe out the Knockout content.
    const pageContentMain = document.getElementById("page-content-main");
    if (pageContentMain) {
      pageContentMain.innerHTML = "";
    }
    const errorConsole = document.getElementById("error-console");
    if (errorConsole) {
      errorConsole.innerHTML = "";
    }

    // Mark as portal page
    document.getElementById("detailMain")?.classList?.add("sb-portal-page-content");

    this.activatedRouteSubscription = this.activatedRoute.paramMap.subscribe(async params => {
      if (this.activatedRoute.snapshot.url[0].path === "ReportDrillDown") {
        const queryParams = this.activatedRoute.snapshot.queryParams;
        this.table = params.get("table");
        this.rsid = queryParams.rsid;
        this.ddid = queryParams.ddid;
        this.displayType = DisplayType.ReportDrillDown;
      }
    });
  }

  async ngAfterViewInit() {
    this.renderKnockoutTemplate();
  }

  // TODO: Is this is the first lifecycle hook where @Input() fields are available?
  ngOnChanges(changes: SimpleChanges) {
    this.renderKnockoutTemplate();
  }

  ngOnDestroy(): void {
    this.activatedRouteSubscription && this.activatedRouteSubscription.unsubscribe();
  }

  private async renderKnockoutTemplate() {
    if (this.table && !this.knockoutTemplateRendered) {
      const element = this.target.nativeElement;

      const ddids = this.reportService.getDrillDownIds(this.rsid, this.ddid);

      const queryJson = {
        and: [
          {
            fieldName: "id",
            operator: "in",
            value: ddids
          }
        ]
      };

      const query = JSON.stringify(queryJson);

      const parameters = {
        table: this.table,
        query: query,
      };

      const response: any = await this.requestService.createRequest()
        .controller("servicely.core.Report")
        .method("drillDownDefinition")
        .data(parameters)
        .execute();

      const data: any = JSON.parse(response.data);

      data.elements[0].rendererProperties['showQueryBuilder'] = 'true';
      data.elements[0].rendererProperties['showTileHeader'] = 'true';
      data.elements[0].rendererProperties['showTileFooter'] = 'true';
      data.elements[0].rendererProperties['showListToolbar'] = 'true';

      const templateParams = {
        rendererProperties: {
          tile: "ReportDrillDown",
        },
        elements: [data],
      };
      (window as any).KO.cleanNode(element);
      (window as any).KO.renderTemplate("container-standard", templateParams, {}, element, "replaceNode");

      this.knockoutTemplateRendered = true;
    }
  }

}
